import React, { useEffect } from "react";
import useUserStore from "../../../utils/storeApp";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import RegistrationOrgForm from "./RegistrationOrgForm";
import XdrSetting from "../XdrSetting";

const RegistrationOrgTopLevel = () => {
  const { customerObj, customerFlag } = useUserStore((state) => ({
    customerObj: state.customerObj,
    customerFlag: state.customerFlag,
  }));
  useEffect(() => {
    const body = document.querySelector("#TopLevelTitle");

    body.scrollIntoView(
      {
        behavior: "smooth",
      },
      500
    );
  }, []);

  return (
    <Layout>
      <HeaderOrg />
      <section className="layout-container">
        <div className="container" id="CreateOrgTop">
          <div className="descript-container container-2">
            <div className="form-title g-clr" id="TopLevelTitle">
              Registration: Top Level Organization
            </div>
            {customerObj.Name && customerFlag ? (
              <div className="alert alert-success" role="alert">
                {customerObj.Name} has been added successfully! You may start
                adding new organizations to this customer.
              </div>
            ) : null}
            If you have an NPI (National Provider Identifier) number, enter the
            10-digit identification number. Otherwise, fill in the information
            below, selecting the organization's specialty, how emails will be
            delivered, and the types of services enabled for this organization.
          </div>
          <RegistrationOrgForm />
        </div>
        <XdrSetting />
      </section>
    </Layout>
  );
};

export default RegistrationOrgTopLevel;
